/**
 * File: positionUtils.ts
 * Description: Utility functions for calculating popup positions
 * Author: System
 * Created: 2025-10-06
 * Last Modified: 2025-10-06
 */

export interface Position {
  top: string;
  left: string;
  transform: string;
}

export const calculatePopupPosition = (
  buttonRef: React.RefObject<HTMLButtonElement>,
  popupRef: React.RefObject<HTMLDivElement>,
): Position => {
  if (!buttonRef?.current || !popupRef?.current) {
    return {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    };
  }

  const buttonRect = buttonRef.current.getBoundingClientRect();
  const popupRect = popupRef.current.getBoundingClientRect();
  const popupHeight = popupRect.height || 400; // fallback if not measured
  const popupWidth = popupRect.width || 320; // fallback if not measured

  // Calculate optimal position relative to button
  let top = buttonRect.bottom + 8;
  let left = buttonRect.left;

  // Adjust if popup would go off bottom of screen
  if (top + popupHeight > globalThis.innerHeight - 16) {
    top = buttonRect.top - popupHeight - 8;
  }

  // Adjust if popup would go off right edge of screen
  if (left + popupWidth > globalThis.innerWidth - 16) {
    left = globalThis.innerWidth - popupWidth - 16;
  }

  // Adjust if popup would go off left edge of screen
  if (left < 16) {
    left = 16;
  }

  // Adjust if popup would still go off top of screen after moving above
  if (top < 16) {
    top = 16;
  }

  return {
    top: `${Math.max(
      16,
      Math.min(top, globalThis.innerHeight - popupHeight - 16),
    )}px`,
    left: `${Math.max(
      16,
      Math.min(left, globalThis.innerWidth - popupWidth - 16),
    )}px`,
    transform: 'none',
  };
};
